module.exports = __webpack_public_path__ + "img/login-left2.a4b5b075.jpg";